import { render, staticRenderFns } from "./OffscreenMenu.vue?vue&type=template&id=92e5f058&"
import script from "./OffscreenMenu.vue?vue&type=script&lang=js&"
export * from "./OffscreenMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92e5f058')) {
      api.createRecord('92e5f058', component.options)
    } else {
      api.reload('92e5f058', component.options)
    }
    module.hot.accept("./OffscreenMenu.vue?vue&type=template&id=92e5f058&", function () {
      api.rerender('92e5f058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/OffscreenMenu.vue"
export default component.exports